module.exports = __webpack_public_path__ + "img/_ABS9793.e48e5979.jpg";